<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :inline="false"
      label-width="140px"
    >
      <div class="title">计划诊断设置</div>
      <el-form-item label="计划提示优化设置" required>
        <div class="flex">
          计划创建后
          <el-form-item prop="daysAfterPlan">
            <el-input
              style="width: 100px"
              maxlength="25"
              size="small"
              clearable
              class="mr10 ipt"
              @input="filterGt0OrFixed0('daysAfterPlan')"
              v-model.trim="ruleForm.daysAfterPlan"
              placeholder=""
            ></el-input
            >天开始统计，转化率低于
          </el-form-item>
          <el-form-item prop="minValue">
            <el-input
              style="width: 100px"
              maxlength="25"
              size="small"
              clearable
              @input="filterGt0OrFixed2('minValue')"
              class="mr10 ipt"
              v-model.trim="ruleForm.minValue"
              placeholder=""
            ></el-input
            >%为建议优化
          </el-form-item>
        </div>

        <div class="form-tip mt10">
          复购提醒计划中商品的转化率低于多少时提示需优化，其他均为表现良好
        </div>
      </el-form-item>
      <el-form-item label="复购统计时间设置" prop="repurchaseValidityDays">
        用户收到复购消息后，
        <el-input
          style="width: 100px"
          maxlength="25"
          size="small"
          clearable
          class="mr10 ipt"
          @input="filterGt0OrFixed0('repurchaseValidityDays')"
          v-model.trim="ruleForm.repurchaseValidityDays"
          placeholder=""
        ></el-input
        >天内的购买算为该次计划的复购
      </el-form-item>
    </el-form>
    <div class="flex flex-center">
      <el-button type="primary" size="small" @click="confirm('ruleForm')"
        >确定</el-button
      >
      <el-button size="small" type="info" @click="$router.back(-1)"
        >返回</el-button
      >
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        daysAfterPlan: "",
        minValue: "",
        repurchaseValidityDays: ""
      },
      rules: {
        daysAfterPlan: {
          required: true,
          message: "请输入",
          trigger: "blur"
        },
        minValue: {
          required: true,
          message: "请输入",
          trigger: "blur"
        },
        repurchaseValidityDays: {
          required: true,
          message: "请输入",
          trigger: "blur"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
  },
  methods: {
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanDiagnosisConfig"
      );

      if (code === "0") {
        if (result.daysAfterPlan) {
          for (let key in this.ruleForm) {
            this.ruleForm[key] = result[key];
          }
        }
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store
            .dispatch("saveRepurchasePlanDiagnosisConfig", params)
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.queryDetails();
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
